/**
 * `utils/device.js`
 *  - デバイス
 *
 * 役割:
 *  - デバイスに応じた条件分岐など
 *
 * 使用方法:
 *  - import {mediaQuery, isMobile, isSafari} from "utils/index.js";
 *    or
 *  - import {mediaQuery, isMobile, isSafari} from "utils/device.js";
 *
 * 関連ファイル
 *  - `utils/index.js`
 */


import Bowser from "bowser";

/**
 * 画面幅に応じてSPかPCを判定
 */
export function mediaQuery(width = window.innerWidth) {
  return width <= 768 ? "sp" : "pc";
}

/**
 * タッチデバイス（SP、タブレット含む）の判別
 */
export const isMobile = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  return (
    browser.getPlatformType(true) === "tablet" ||
    browser.getPlatformType(true) === "mobile" ||
    "ontouchstart" in window
  );
};

/**
 * Safariブラウザの判別（一部バグ回避用）
 */
export const isSafari = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);
  return browser.getBrowserName() === "Safari";
};